module.exports = __webpack_public_path__ + "img/basic_btn.d26ee9d8.png";